// Libs
import { TiTick } from "react-icons/ti";

export default function SuccessIcon() {
  return (
    <>
      <div className="p-5 rounded-full bg-dashboard text-white">
        <TiTick size={40} />
      </div>
    </>
  );
}
